import { ActionReducer } from "@ngrx/store";
import { logOutSuccess } from "../actions/login/login.actions";

export function clearStateMetaReducer(
  reducer: ActionReducer<any>,
): ActionReducer<any> {
  return (state, action) => {
    if (action.type === logOutSuccess.type) {
      state = {};
    }
    return reducer(state, action);
  };
}
